<script>
import dashboardNumberFormat from '../mixins/dashboardNumberFormat';

export default {
    name: 'KpiCompositeGrid',
    mixins: [dashboardNumberFormat],
    props: {
        heroValue: {
            type: [Number, String],
            default: 0,
        },
        heroLabel: {
            type: String,
            default: '',
        },
        heroKey: {
            type: String,
            default: '',
        },
        metrics: {
            type: Array,
            default: () => [],
        },
        heroBoxColor: {
            type: String,
            default: 'bg-purple',
        },
        heroIcon: {
            type: String,
            default: 'fa-line-chart',
        },
        metricPalette: {
            type: Array,
            default: () => ['bg-aqua', 'bg-teal', 'bg-maroon'],
        },
    },
    methods: {
        metricColor(index) {
            const palette = this.metricPalette.length > 0
                ? this.metricPalette
                : ['bg-aqua', 'bg-teal', 'bg-maroon'];

            return palette[index % palette.length];
        },
        formatHero() {
            return this.formatKpiValue(this.heroValue, this.heroKey);
        },
    },
};
</script>

<template>
    <div class="row kpi-summary">
        <div class="col-sm-5 kpi-summary__hero">
            <div class="small-box" :class="heroBoxColor">
                <div class="inner">
                    <h3>{{ formatHero() }}</h3>
                    <p>{{ heroLabel }}</p>
                </div>
                <div class="icon">
                    <i class="fa" :class="heroIcon" />
                </div>
            </div>
        </div>
        <div class="col-sm-7">
            <div class="kpi-summary__metrics">
                <div
                    v-for="(metric, index) in metrics"
                    :key="metric.key"
                    class="kpi-summary__metric"
                >
                    <div class="small-box" :class="metricColor(index)">
                        <div class="inner">
                            <h3>{{ formatKpiValue(metric.value, metric.key) }}</h3>
                            <p>{{ metric.label }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
